// ENGLISH WORDS
const english =[
    
]

export default english